// Taxonomia de erro da SPA e o mapa de status HTTP.
//
// A separação entre "falha do usuário" e "erro sistêmico" mora aqui: é ela que
// decide se a tela mostra um toast corrigível, destaca um campo, ou abre um
// modal com código de suporte.

export const TipoErro = {
  CANCELADO: "cancelado",
  VALIDACAO: "validacao",
  NEGOCIO: "negocio",
  SESSAO: "sessao",
  PERMISSAO: "permissao",
  NAO_ENCONTRADO: "naoEncontrado",
  CONFLITO: "conflito",
  ARQUIVO_GRANDE: "arquivoGrande",
  EXCESSO_REQUISICOES: "excessoRequisicoes",
  INDISPONIVEL: "indisponivel",
  REDE: "rede",
  SISTEMICO: "sistemico",
};

// Erro que o usuário consegue resolver sozinho na própria tela.
export const ehFalhaDoUsuario = (tipo) =>
  tipo === TipoErro.VALIDACAO ||
  tipo === TipoErro.NEGOCIO ||
  tipo === TipoErro.NAO_ENCONTRADO ||
  tipo === TipoErro.CONFLITO ||
  tipo === TipoErro.ARQUIVO_GRANDE;

// Erro em que não há o que o usuário faça na tela: abre modal e, quando o
// servidor mandou, mostra o código de suporte. Rede entra aqui porque também não
// é corrigível no formulário -- o modal não some sozinho como o toast, e quem
// está no meio de um pagamento precisa ler que a operação não chegou ao servidor.
export const ehErroSistemico = (tipo) =>
  tipo === TipoErro.INDISPONIVEL ||
  tipo === TipoErro.SISTEMICO ||
  tipo === TipoErro.REDE;

export const CHAVE_I18N = {
  [TipoErro.VALIDACAO]: "VALIDACAO",
  [TipoErro.NEGOCIO]: "NEGOCIO",
  [TipoErro.SESSAO]: "SESSAO",
  [TipoErro.PERMISSAO]: "PERMISSAO",
  [TipoErro.NAO_ENCONTRADO]: "NAO_ENCONTRADO",
  [TipoErro.CONFLITO]: "CONFLITO",
  [TipoErro.ARQUIVO_GRANDE]: "ARQUIVO_GRANDE",
  [TipoErro.EXCESSO_REQUISICOES]: "EXCESSO_REQUISICOES",
  [TipoErro.INDISPONIVEL]: "INDISPONIVEL",
  [TipoErro.REDE]: "REDE",
  [TipoErro.SISTEMICO]: "SISTEMICO",
};

// O backend classifica o erro em erros[].tipo. Enquanto ele devolver todo erro
// de negócio em HTTP 400, o status sozinho não distingue "corrija o campo" de
// "o sistema falhou". Quando o backend informa o tipo, ele sabe mais que o status.
export const TIPO_DO_BACKEND = {
  Validacao: TipoErro.VALIDACAO,
  Negocio: TipoErro.NEGOCIO,
  NaoEncontrado: TipoErro.NAO_ENCONTRADO,
  Conflito: TipoErro.CONFLITO,
  Indisponibilidade: TipoErro.INDISPONIVEL,
  Sistemico: TipoErro.SISTEMICO,
  Cancelado: TipoErro.CANCELADO,
};

// Só para 400/422, que é o balaio onde o backend joga tudo. Nos demais status o
// próprio status já é específico (403 -> permissão) e diz mais que o tipo.
export const STATUS_GENERICO = [400, 422];

export const tipoPorStatus = (status) => {
  if (status === 400) return TipoErro.VALIDACAO;
  if (status === 401) return TipoErro.SESSAO;
  if (status === 403) return TipoErro.PERMISSAO;
  if (status === 404) return TipoErro.NAO_ENCONTRADO;
  if (status === 409) return TipoErro.CONFLITO;
  if (status === 413) return TipoErro.ARQUIVO_GRANDE;
  if (status === 422) return TipoErro.VALIDACAO;
  if (status === 429) return TipoErro.EXCESSO_REQUISICOES;
  if (status >= 500) return TipoErro.INDISPONIVEL;
  return TipoErro.SISTEMICO;
};

// A rede de segurança do lado do cliente: mesmo que algum serviço volte a vazar
// detalhe interno, o navegador não exibe. Casa stack trace .NET, tipos do
// framework, SQLSTATE do Postgres, texto de constraint e corpo JSON/HTML cru.
export const CONTEUDO_TECNICO =
  /\bat\s+[A-Z][\w.]*\(|StackTrace|Npgsql|SQLSTATE|System\.[A-Z]|Microsoft\.[A-Z]|Newtonsoft\.|EntityFrameworkCore|violates .*constraint|duplicate key value|relation "|\b2[23]\d{3}\b|<!DOCTYPE|<html/i;

export const pareceTecnica = (mensagem) =>
  typeof mensagem === "string" && CONTEUDO_TECNICO.test(mensagem);

// Sentinela genérica emitida pelo pipeline de exceção do backend. O acoplamento
// por string não some enquanto houver serviço antigo, mas fica declarado num
// lugar só.
export const SENTINELA_GENERICA = "Ocorreu um erro";

export const ehSentinelaGenerica = (mensagem) =>
  typeof mensagem === "string" &&
  mensagem.trim().toLowerCase() === SENTINELA_GENERICA.toLowerCase();

// O ApiService já mostra o erro antes de rejeitar a promise. Quando a tela
// também chama tratarErro() -- para destacar o campo culpado -- ela não deve
// mostrar a mesma mensagem de novo. A marca no próprio objeto de erro é o que
// permite as duas coisas conviverem sem o usuário ver o aviso duplicado.
export const marcarComoApresentado = (err) => {
  try {
    if (err && typeof err === "object") err.valoremApresentado = true;
  } catch (e) {
    // erro imutável (raro): o pior caso é um aviso repetido
  }
};

export const jaFoiApresentado = (err) =>
  !!(err && typeof err === "object" && err.valoremApresentado);
